import { config } from "../config/common";

// prefix urls without protocol with "//" to open correctly
export const makeUrlClickable = (url: string) => {
  const isClickable = url.startsWith("http://") || url.startsWith("https://");

  if (isClickable) return url;

  return `//${url}`;
};

export const constructWebmediaPhotoUrl = (
  photoId: string,
  onlineApplicationId: string | number
) =>
  `${config.webMediaImageUrl}/~upload/onlineApplications/${onlineApplicationId}/images/${photoId}.jpg`;
